import "./style.scss";
import { FC } from "react";
import { AOPSwitzerlandAdmissionData } from "@/src/types/admissionOffice";
import backForAdmissionBlankSwiss from "@/src/assets/admissionOfficePage/back-for-admission-blank-swiss.webp";

interface AOPPrevProps {
  bodyForPrev: AOPSwitzerlandAdmissionData;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev }) => {
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";

  return (
    <div className="admission-office-prev-wrapper">
      <div className="admission-office-prev switzerland admission">
        <img className="admission-office-prev-background" src={backForAdmissionBlankSwiss} alt="" />
        <div className="admission-office-prev-section number-and-date">
          <span>№ - </span>
          <span>Date: {dateLine}</span>
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName || ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth || ""}</p>
          <p>Nationality: {bodyForPrev.nationality || ""}</p>
          <p>Pasport Number: {bodyForPrev.passport_number || ""}</p>
          <br />
          <p>Subject: {bodyForPrev.course || ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction || ""}</p>
          <p>Duration: {bodyForPrev.duration || ""}</p>
          <p>Academic Year: {bodyForPrev.academicYear || ""}</p>
        </div>
        {bodyForPrev.body?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.body.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
